import type {CSSProperties, ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {isMigratedLegacyPath, isPortalRouteHybridEnabled, navigateToMigratedRouteOnNewPortal} from 'src/lib/portal-migration'
import {isNewPortalEnabledForPath} from 'src/lib/portal-migration/portal-module-prefs'
import {readPortalModulePrefsFromClientCookie} from 'src/lib/portal-migration/portal-module-prefs.client'

type Props = {
  route: string
  className?: string
  style?: CSSProperties
  title?: string
  onNavigate?: () => void
  children: ReactNode
  'data-slot'?: string
  'data-active'?: boolean
}

export function SidebarNavLink({route, className, style, title, onNavigate, children, ...dataAttrs}: Props) {
  const prefs = readPortalModulePrefsFromClientCookie()
  const useNewPortal = isPortalRouteHybridEnabled() && isMigratedLegacyPath(route) && isNewPortalEnabledForPath(route, prefs)

  if (useNewPortal) {
    return (
      <a
        href={route}
        {...dataAttrs}
        title={title}
        className={className}
        style={style}
        onClick={(event) => {
          event.preventDefault()
          onNavigate?.()
          navigateToMigratedRouteOnNewPortal(route)
        }}>
        {children}
      </a>
    )
  }

  return (
    <Link {...dataAttrs} to={route} className={className} style={style} title={title} onClick={onNavigate}>
      {children}
    </Link>
  )
}
